import { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Nav.module.css";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const loggedIn = localStorage.getItem("userlogged") === "visible";
  return (
    <nav className={styles.nav}>
      <Link to="/" className={styles.brand}>
        <span className={styles.dot} aria-hidden="true" /> Urban Services
      </Link>
      <button
        className={styles.toggle}
        aria-expanded={open}
        aria-label="Toggle menu"
        onClick={() => setOpen((v) => !v)}
      >
        ≡
      </button>
      <ul className={`${styles.links} ${open ? styles.show : ""}`}>
        <li>
          <a href="/#services" onClick={() => setOpen(false)}>
            Services
          </a>
        </li>
        <li>
          {loggedIn ? (
            <Link to="/profile" onClick={() => setOpen(false)}>
              Profile
            </Link>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)}>
              Login
            </Link>
          )}
        </li>
      </ul>
    </nav>
  );
}
